"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DIMS_INIT_STATE = void 0;
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
exports.DIMS_INIT_STATE = {
    width: document.body.clientWidth,
    height: document.body.clientHeight
};
const dims = (state = (0, cloneDeep_1.default)(exports.DIMS_INIT_STATE), action) => {
    switch (action.type) {
        case 'SET_DIMS': {
            return Object.assign({}, action.dims);
        }
        default: {
            return state;
        }
    }
};
exports.default = dims;
